<template>
  <div class="">
    <div class="head-title">参数配置</div>
    <div class="">
      <div class="">
        <div class="">
          <el-form
            ref="form"
            :model="data"
            label-width="10rem"
            style="margin-top: 4rem"
          >
            <el-form-item label="ID:">
              <el-input
                clearable
                v-model="data.tableData.client_id"
                style="width: 20%"
                placeholder="请输入ID"
                ></el-input
              >
            </el-form-item>
            <el-form-item label="密钥:">
              <el-input
                clearable
                v-model="data.tableData.client_secret"
                style="width: 20%"
                placeholder="请输入密钥"
                >></el-input
              >
            </el-form-item>
            <el-form-item >
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      data: {
        tableData: {},
      },
      msg: "2",
      radio: "1",
      username: "",
      title: {},
      tooken: "",
      code: "",
      accesstoken: "",
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中\
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.about();
    this.cheshi();
    this.codes();
  },
  methods: {
    codes() {
      this.code = this.getQuery(location.href, "code");
      if (this.code) {
        this.axios
          .post(
            "/weimob/index/check_auth",
            qs.stringify({
              phone: this.tooken.phone,
              code: this.code,
              redirect_uri:
                "https://work.weijub.com/#/register/user/paramBinbing",
            }),
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )
          .then((res) => {})
          .catch(function (err) {});
      }
    },
    // 提交过后输出的数据\
    // headlgetAgentUser
    toggleStatuss() {
      this.axios
        .post(
          "/crm/CrmConfig/addCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            leads_config: this.data.tableData.leads_config,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
        })
        .catch(function (err) {});
    },
    toggleStatus() {
      this.axios
        .post(
          "/crm/CrmConfig/addCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            customer_config: this.data.tableData.customer_config,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
        })
        .catch(function (err) {});
    },
    about() {
      this.axios
        .post(
          "/crm/CrmConfig/getCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 0) {
            this.data.tableData == {};
          } else if (res.data.code == 1) {
            this.data.tableData = res.data.data;
          }
        })
        .catch(function (err) {});
    },
    onSubmit() {
      this.axios
        .post(
          "/crm/CrmConfig/addCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            client_id: this.data.tableData.client_id,
            client_secret: this.data.tableData.client_secret,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          this.about();
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.axios
              .post(
                "/weimob/index/add_secret",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  client_id: this.data.tableData.client_id,
                  client_secret: this.data.tableData.client_secret,
                  redirect_uri:
                    "https://work.weijub.com/#/register/user/paramBinbing",
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                location.href = res.data.data;
              })
              .catch(function (err) {});
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    cheshi() {
      this.axios
        .post(
          "/weimob/index/check_secret",
          qs.stringify({
            phone: this.tooken.phone,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
          if (res.data.code == 1) {
            this.axios
              .post(
                "/weimob/index/get_access_token",
                qs.stringify({
                  phone: this.tooken.phone,
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.accesstoken = res.data.data;
                }
                if (res.data.code == 0) {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(function (err) {});
          }
        })
        .catch(function (err) {});
    },
    getQuery(url, name) {
      let strs;
      let index = url.indexOf("?");
      if (index !== -1) {
        strs = url.slice(index + 1).split("&");
      }
      for (let k = 0; k < strs.length; k++) {
        let splitItem = strs[k].split("=");
        if (splitItem[0] === name) {
          return splitItem[1];
        }
      }
    },
  },
  // 1.用户分配
  // 2.用户分配
  //3.用户选择 附件管理
};
</script>
<style scoped>

</style>


